<app-table-standard-layout [dataSource$]="categories$" [title]="'Categories'" [columnSettings]="columnSettings"
  [rowActionButtons]="rowActionButtons" [topbarActionButton]="topbarActionButton" [showImport]="false" >
</app-table-standard-layout>